import React, { useState, useEffect } from "react";
import MobileNavigationItem from "./MobileNavigationItem";

const MobileMenu = (settings) => {
  const navData = () => {
    return settings.content.header_navigation.map((item) => {
      return {
        ...item,
        open: false,
        navigation_sections:
          item.submenu?.length > 1
            ? item.submenu.map((section) => {
                return {
                  ...section,
                  open: false,
                };
              })
            : item.submenu.length === 1
            ? item.submenu[0]?.map((link) => {
                return {
                  ...link,
                  links: [],
                };
              })
            : [],
      };
    });
  };

  const [data, setData] = useState(navData());

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [open]);

  const handleClick = () => {
    setOpen(!open);
    setData(navData());
  };

  const handleNavItemClick = (_uid) => {
    setData((data) =>
      data.map((item) => {
        return {
          ...item,
          open: _uid === item._uid ? !item.open : false,
        };
      })
    );
  };

  const handleNavLinkClick = (_uid) => {
    setData((data) =>
      data.map((item) => {
        return {
          ...item,
          navigation_sections: item.submenu.map((section) => {
            return {
              ...section,
              open: _uid === section._uid ? !section.open : false,
            };
          }),
        };
      })
    );
  };

  return (
    <>
      <div
        className="pl-2 flex tlfcustom:hidden"
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        tabIndex="0"
      >
        <button className="w-[22px] h-[16px] relative focus:outline-none outline-none">
          <div
            className={`h-[2px] bg-darkgrey w-full absolute left-0 transform-gpu translate-z-0 transition-all duration-300 -translate-y-1/2 ${
              open ? "top-1/2 rotate-[135deg]" : "top-0 rotate-0"
            }`}
          ></div>
          <div
            className={`h-[2px] bg-darkgrey w-full absolute left-0 transform-gpu translate-z-0 transition-all duration-300 -translate-y-1/2 ${
              open ? "opacity-0" : "top-1/2 rotate-0"
            }`}
          ></div>
          <div
            className={`h-[2px] bg-darkgrey w-full absolute left-0 transform-gpu translate-z-0 transition-all duration-300 translate-y-1/2 ${
              open ? "bottom-1/2 rotate-[-135deg]" : "bottom-0 rotate-0"
            }`}
          ></div>
        </button>
      </div>
      <div
        className={`bg-red lg:hidden h-[calc(100vh-124px)] w-screen fixed top-[124px] px-6 pt-8 pb-16 transition-all duration-300 ${
          open ? "left-0" : "-left-full"
        }`}
      >
        <div className="">
          {data.map((item, index) => (
            <MobileNavigationItem
              {...item}
              handleNavItemClick={handleNavItemClick}
              handleNavLinkClick={handleNavLinkClick}
              key={index}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
